export const getFileBase64 = (file: File | Blob): Promise<string | ArrayBuffer | null> =>
    new Promise((resolve) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result), false);
        reader.readAsDataURL(file);
    });

export const bytesToMegabytes = (bytes: number) => (bytes / (1024 * 1024)).toFixed(0).replace(/,/g, '');
